import React from "react";

const MainButton = ({ children, ...props }) => {
    return (
        <button
            className="py-[9px] w-full bg-primary text-white rounded text-center"
            {...props}
        >
            <span className="font-semibold text-sm leading-[22px]">
                {children}
            </span>
        </button>
    );
};

export default MainButton;
